import React from "react";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

// Assets
import mainImage from "../../assets/backgrounds/get-connected-bg.png";
import { urls } from "../../config/urls";

// Components
import Section from "../../components/Section/Section";
import Text, { types } from "../../components/Text/Text";
import LinkScroll from "../../components/LinkScroll/LinkScroll";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: "132px",
    paddingBottom: "90px",
    background:
      "transparent linear-gradient(109deg, #3ACCE1 0%, #1CAFC4 100%) 0% 0% no-repeat padding-box",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      gap: 0,
      paddingTop: "32px",
      paddingBottom: "32px"
    }
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: theme.spacing(2)
  },
  heading: {
    color: "#fff",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      width: "100%"
    }
  },
  title: {
    color: "#fff",
    maxWidth: "17ch",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      width: "100%",
      maxWidth: "100%"
    }
  },
  image: {
    width: "812px",
    [theme.breakpoints.down("md")]: {
      width: "30vw"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "500px"
    }
  },
  button: {
    fontFamily: "Montserrat Black",
    textTransform: "none",
    fontSize: "24px",
    padding: "28px 124px",
    borderRadius: "10px",
    boxShadow: "0px 3px 66px #00000029",
    backgroundColor: "#0B4283",
    color: "#fff",
    lineHeight: 1,
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
      padding: "24px 90px"
    },
    [theme.breakpoints.down(1440)]: {
      fontSize: "14px",
      marginBottom: theme.spacing(4),
      padding: "24px 70px"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginBottom: theme.spacing(4),
      padding: "24px 0",
      width: "100%"
    }
  }
}));

const GetConnected = () => {
  const classes = useStyles();

  return (
    <Section className={classes.root}>
      <div className={classes.textWrapper}>
        <Text type={types.homeSectionHeading} className={classes.heading}>
          Empower our users to share their evidence with you
        </Text>
        <Text type={types.homeSectionTitle} className={classes.title}>
          Get your organisation connected
        </Text>
        <Button
          className={classes.button}
          component={LinkScroll}
          to={`${urls.getConnected}#pageStart`}
          color="secondary"
          variant="contained"
          disableElevation
        >
          See the Benefits
        </Button>
      </div>
      <div className={classes.imageWrapper}>
        <img src={mainImage} className={classes.image} alt="Get connected" />
      </div>
    </Section>
  );
};

export default GetConnected;
